import styled from "styled-components";

export default styled.div`
  margin-left: auto;
  height: 100%;
`;
